// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  LANG_DE_TRANS,
  LANG_DE_START_TRANS,
  LANG_DE_CONTRACT_TRANS,
  LANG_DE_CONTRACT_BANK_ACCOUNT_DETAILS_TRANS,
  LANG_DE_CONTRACT_CONTRACT_DETAILS_TRANS,
  LANG_DE_CONTRACT_RENT_DETAILS_TRANS,
  LANG_DE_CONTRACT_CONTACT_PERSONS_TRANS,
  LANG_DE_ISSUES_TRANS,
  LANG_DE_UNLOCK_TRANS,
  LANG_DE_AGREEMENT_TRANS,
  LANG_DE_VERIFYEMAIL_TRANS,
  LANG_DE_REGISTRATION_TRANS,
  LANG_DE_LOGOUT_TRANS,
  LANG_DE_CONTRACT_REQUEST_DOCUMENTS_TRANS,
  LANG_DE_DOCUMENTS_TRANS,
  LANG_DE_PUBLIC_ENTERPIN_TRANS,
  LANG_DE_PIN_TRANS,
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_CONNECTCONTRACT_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS,
  LANG_DE_PUBLIC_WELCOME_TRANS,
  LANG_DE_LPA_START_TRANS,
  LANG_DE_LPA_ERROR_TRANS,
  LANG_DE_ERROR_TRANS,
  LANG_DE_REGISTRATION_CREATEACCOUNT_TRANS,
  LANG_DE_CONSUMPTIONS_TRANS,
  LANG_DE_LPA_DATE_TRANS,
} from 'apps/mietercockpit/src/translations/de';

export function overrideTranslations() {
  (LANG_DE_TRANS['PAGETITLE_PREFIX'] = 'GESOBAU Berlin: '),
    (LANG_DE_TRANS['BALANCE'] = 'Kontostand'),
    (LANG_DE_TRANS['MY_NEWS'] = 'Gesobau News');
  LANG_DE_TRANS['LOGINWELCOME'] = ' ';
  LANG_DE_TRANS['SELECT_NOTIF_TYPE_HEADING'] = 'Rund-um-die-Uhr-Service';
  LANG_DE_TRANS['USERPAGE_SUBHEADING'] =
    'Hier können Sie z. B. den Mietvertrag auswählen, zu dem Sie Informationen einsehen möchten, oder Ihr Kennwort erneuern.';
  LANG_DE_TRANS['REQUEST_DOCUMENT'] = 'Anfordern';
  LANG_DE_TRANS['NO_DATA_FOR_CONSUMPTION_APP'] =
    'Leider ist für Ihre Wohnanlage keine Anzeige von Verbrauchswerten über die GESOBAU Berlin App möglich.';
  LANG_DE_TRANS['PRIVACY_POLICY'] = 'Datenschutzrichtlinie';
  (LANG_DE_TRANS['CHATBOT_SEARCH_PLACEHOLDER'] = 'z.B. Heizung im Bad kaputt'),
    (LANG_DE_CONTRACT_REQUEST_DOCUMENTS_TRANS['REQUEST_CONFIRMATION_DOCUMENTS'] =
      ' Wollen Sie das Dokument wirklich anfordern?');
  // #582 intro company logo alt text
  LANG_DE_TRANS.UI_COMPANY_LOGO = 'Logo der Gesobau';
  LANG_DE_TRANS['SELECT_NOTIF_TYPE_SUBHEADING'] =
    'Sie möchten einen Schaden melden, eine Genehmigung einholen oder haben ein anderes Anliegen? Hier sind Sie richtig.';
  LANG_DE_TRANS['SOMETHING_WENT_WRONG_TEXT'] =
    'Bitte probieren Sie es später nochmal oder wenden Sie sich an die Kundenbetreuung. Vielen Dank.';
  LANG_DE_TRANS['ACTION_PANEL_BUTTON_TEXT'] = 'Aktion ausführen';
  LANG_DE_CONSUMPTIONS_TRANS['TREND_DESCRIPTION_HEATING'] = 'Trend Vergleichswert: Wohnhausgruppe';
  LANG_DE_CONSUMPTIONS_TRANS['BENCHMARK_LEGEND_TEXT'] =
    'Vergleichswert Wohnhausgruppe hochgerechnet mit der Wohnfläche dieser Wohnung';
  LANG_DE_CONTRACT_TRANS['PAGE_HEADING'] = 'Alles auf einen Klick';
  LANG_DE_CONTRACT_TRANS['PAGE_SUBHEADING'] = 'Ihr Vertrag: Daten einsehen oder Kontaktperson finden.';
  LANG_DE_TRANS.NOT_VALID_E164_ERROR_MESSAGE_1 =
    'Bitte geben Sie die Telefonnummer mit Vorwahl und Rufnummer ein (z.B. +49 30 1234567).';

  LANG_DE_CONTRACT_BANK_ACCOUNT_DETAILS_TRANS['PAGE_SUBHEADING'] =
    'Ihre Bankverbindung hat sich geändert? Teilen Sie uns an dieser Stelle Ihre neuen Kontodaten mit.';
  LANG_DE_CONTRACT_CONTRACT_DETAILS_TRANS['PAGE_SUBHEADING'] =
    'Finden Sie hier die wichtigsten Infos zu Ihrem Mietverhältnis, z. B. den Vertragsbeginn oder die Wohn- und Heizfläche.';
  LANG_DE_CONTRACT_CONTACT_PERSONS_TRANS['PAGE_SUBHEADING'] =
    'Es gibt auch Anliegen, die Sie direkt mit uns besprechen müssen. Hier finden Sie unsere Kontaktdaten:';
  LANG_DE_CONTRACT_RENT_DETAILS_TRANS['PAGE_SUBHEADING'] =
    'Im Blick: Wie sich Ihre Miete aus Grundmiete, Betriebskosten und gegebenenfalls Zuschlägen zusammensetzt.';

  LANG_DE_ISSUES_TRANS['PAGE_HEADING'] = 'Ihre Fragen an uns.';
  LANG_DE_ISSUES_TRANS['PAGE_SUBHEADING'] =
    'Schadensmeldungen, Aufträge und Anfragen im Blick: Erfahren Sie den aktuellen Stand Ihrer Anliegen.';

  LANG_DE_START_TRANS['PAGE_SUBHEADING'] =
    'für Ihre Zufriedenheit setzen wir alles in Bewegung. Nutzen Sie unsere GESOBAU Berlin App, um aktuelle Informationen zu erhalten und uns Ihre Anliegen mitzuteilen.';
  LANG_DE_START_TRANS['WELCOME'] = 'Herzlich willkommen\n';
  LANG_DE_START_TRANS['USER_ACTIVATION_TEXT'] =
    'Damit Sie alle Funktionen des Kundenportals nutzen können, benötigen Sie Ihren Aktivierungscode, den wir Ihnen im Zuge Ihrer Registrierung per Post zugesendet haben.';
  LANG_DE_START_TRANS['NO_CONTRACT_CONNECTED_TEXT'] = 'Wenn Sie Mieter*in sind, können Sie hier Ihren Mietvertrag verknüpfen und praktische Funktionen rund um Ihr Mietverhältnis freischalten.';

  LANG_DE_UNLOCK_TRANS['PAGE_SUBHEADING'] = 'Einfach Ihr Gerät entsperren und die GESOBAU Berlin App nutzen';
  LANG_DE_UNLOCK_TRANS['UNLOCK_IOS_TOUCH'] = 'Jetzt mit Touch ID in der GESOBAU Berlin App anmelden';
  LANG_DE_UNLOCK_TRANS['UNLOCK_ANDROID_TITLE'] = 'GESOBAU Berlin App';
  LANG_DE_UNLOCK_TRANS['UNLOCK_ANDROID_MESSAGE'] = 'Jetzt mit Touch in der GESOBAU Berlin App anmelden';

  LANG_DE_ERROR_TRANS['SERVICE_NOT_AVAILABLE_TEXT2'] =
    'In dringenden Fällen erreichen Sie uns telefonisch unter <a href="tel:+493040730">030 - 4073 - 0</a>.';

  LANG_DE_AGREEMENT_TRANS['AGREEMENT_TEXT_3'] =
    'Um die GESOBAU Berlin App weiterhin nutzen zu können, bestätigen Sie bitte, dass Sie die neuen';

  LANG_DE_VERIFYEMAIL_TRANS['PAGE_SUBHEADING_OK'] =
    'Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Viel Vergnügen bei der Nutzung der GESOBAU Berlin App.';
  LANG_DE_REGISTRATION_TRANS['REGISTRATION_COMPLETE_TEXT'] =
    'Damit Ihnen alle Funktionen der GESOBAU Berlin App uneingeschränkt zur Verfügung stehen, bestätigen Sie bitte den Link, den wir an Ihre E-Mail-Adresse geschickt haben.';
  LANG_DE_REGISTRATION_CREATEACCOUNT_TRANS['PAGE_SUBHEADING'] = 'Nur mit gültigem Mietvertrag';
  LANG_DE_LOGOUT_TRANS['ACCOUNT_DELETED_TEXT'] =
    'Wir haben alle Benutzerdaten erfolgreich aus unserem System entfernt. Falls Sie in Zukunft die GESOBAU Berlin App wieder nutzen wollen, freuen wir uns sehr. Dafür registrieren Sie sich bitte neu.';

  LANG_DE_DOCUMENTS_TRANS['PAGE_SUBHEADING'] = 'Hier können Sie Ihre Dokumente einsehen.';

  LANG_DE_PUBLIC_ENTERPIN_TRANS['NEW_PIN_REQUESTED'] =
    'Wir haben Ihre Anfrage erhalten und werden Ihnen einen neuen Aktivierungscode per Post zusenden.';
  LANG_DE_PUBLIC_ENTERPIN_TRANS['PIN_REQUEST_DATE_TEXT'] = 'Ihr Aktivierungscode wurde angefordert am';
  LANG_DE_PUBLIC_ENTERPIN_TRANS['REQUEST_PIN'] = 'Aktivierungscode erneut anfordern';
  LANG_DE_PUBLIC_ENTERPIN_TRANS['PIN_EXPIRED_INFO_TEXT2'] =
    'Stunden einen neuen Aktivierungscode anfordern. Dieser wird Ihnen dann per Post zugesandt. Bitte beachten Sie, dass die Zusendung des Aktivierungscodes einige Tage in Anspruch nehmen kann.';
  LANG_DE_PUBLIC_ENTERPIN_TRANS['PIN_NOT_VALID'] = 'Der von Ihnen eingegebene Aktivierungscode ist ungültig.';
  LANG_DE_PUBLIC_ENTERPIN_TRANS['VERIFY_PIN'] = 'Aktivierungscode verifizieren';

  LANG_DE_PIN_TRANS['NEW_PIN_REQUESTED'] =
    'Wir haben Ihre Anfrage erhalten und werden Ihnen einen neuen Aktivierungscode per Post zusenden.';
  LANG_DE_PIN_TRANS['PAGE_SUBHEADING'] =
    'Bitte geben Sie hier den sechsstelligen Aktivierungscode ein, den wir Ihnen per Post zugesandt haben.';
  LANG_DE_PIN_TRANS['PIN_REQUEST_DATE_TEXT'] = 'Ihr Aktivierungscode wurde angefordert am';
  LANG_DE_PIN_TRANS['REQUEST_PIN'] = 'Aktivierungscode erneut anfordern';
  LANG_DE_PIN_TRANS['PIN_EXPIRED_INFO_TEXT'] =
    'Sie können nach Ablauf von 72 Stunden einen neuen Aktivierungscode anfordern. Dieser wird Ihnen das per Post zugesandt. Bitte beachten Sie, dass die Zusendung des Aktivierungscodes einige Tage in Anspruch nehmen kann.';
  LANG_DE_PIN_TRANS['PIN_NOT_VALID'] = 'Der von Ihnen eingegebene Aktivierungscode ist ungültig.';
  LANG_DE_PIN_TRANS['VERIFY_PIN'] = 'Aktivierungscode verifizieren';

  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['CONTRACT_TYPE_SELECTION_LABEL'] = 'Bitte wählen Sie Ihren Vertragstyp aus:';
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['NO_CONTRACT_DATA'] = 'Sie haben Ihre Vertragsdaten nicht zur Hand?';
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['NO_CONTRACT_DATA_TEXT'] =
    'Teilen Sie uns Ihre Adresse mit, dann ermitteln wir Ihre Vertragsdaten. Nachdem wir Sie als Mieter*in identifiziert haben, senden wir Ihnen einen Aktivierungscode per Post zu.';
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['PAGE_SUBHEADING'] = 'Nur mit gültigem Mietvertrag';
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['PAGE_DESCRIPTION_ALTERNATIVE'] = 'Bitte teilen Sie uns Ihren Namen und die Adressdaten zu Ihrem Mietverhältnis mit, damit wir Sie identifizieren können.';
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS['PAGE_DESCRIPTION_ALTERNATIVE_FORCED'] = 'Leider konnten wir Sie über die Mietvertragsdaten nicht identifizieren. Bitte teilen Sie uns Ihren Namen und die Adressdaten zu Ihrem Mietverhältnis mit, damit wir Sie identifizieren können.';

  LANG_DE_LOGINWITHOUTREGISTRATION_CONNECTCONTRACT_TRANS['NO_CONTRACT_DATA_TEXT'] =
    'Geben Sie Ihre Daten ein und wir ermitteln Ihre Vertragsdaten. Nachdem wir Sie als Mieter identifiziert haben, schicken wir Ihnen einen Aktivierungscode per Post zu.';

  LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS['REQUEST_PIN_AGAIN'] = 'Aktivierungscode erneut anfordern';
  LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS['SEND_DATA'] = 'Aktivierungscode überprüfen';

  LANG_DE_PUBLIC_WELCOME_TRANS['PAGE_HEADING'] = 'Sind Sie Mieter*in?';
  LANG_DE_PUBLIC_WELCOME_TRANS['PAGE_DESCRIPTION'] =
    'Um alle Funktionen des Kundencockpits nutzen zu können, benötigen Sie einen gültigen Vertrag mit der Gesobau.';

  LANG_DE_LPA_START_TRANS['OPTION_CONTRACTNUMBER_DESCRIPTION'] =
    'Authentifizieren Sie sich als GESOBAU-Mieter:in mit Ihrer Mietvertragsnummer. Sie finden diese auf dem Anschreiben oder Ihrem Mietvertrag.';
  LANG_DE_LPA_START_TRANS['OPTION_DATE_BIRTHDATE_DESCRIPTION'] =
    'Authentifizieren Sie sich als GESOBAU-Mieter:in mit Ihrem Geburtsdatum.';
  LANG_DE_LPA_START_TRANS['OPTION_DATE_CONTRACTBEGINDATE_DESCRIPTION'] =
    'Authentifizieren Sie sich als GESOBAU-Mieter:in mit dem Datum Ihres Mietvertragsbeginns.';
  LANG_DE_LPA_START_TRANS['OPTION_IDP_DESCRIPTION'] = 'Zugang über die GESOBAU Berlin-App.';

  LANG_DE_LPA_ERROR_TRANS['GESOBAU Logo'];
  
  LANG_DE_LPA_DATE_TRANS['SECTION_MAIN_MESSAGE_BIRTHDATE'] = 'Authentifizieren Sie sich als GESOBAU-Mieter:in mit Ihrem Geburtsdatum.'
}
